'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DRAFTJS_BLOCK_KEY = exports.DRAFTJS_BLOCK_KEY = 'DRAFTJS_BLOCK_KEY';
var DRAFTJS_BLOCK_TYPE = exports.DRAFTJS_BLOCK_TYPE = 'DRAFTJS_BLOCK_TYPE';


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-drag-n-drop-plugin/lib/constants/index.js
// module id = 719
// module chunks = 0